import { render, staticRenderFns } from "./AdminWizardLayer.vue?vue&type=template&id=d4f8e5ec"
import script from "./AdminWizardLayer.vue?vue&type=script&lang=ts"
export * from "./AdminWizardLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports